<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-text">
                            为鼓励企业引进和培育急需紧缺专业技术人才，按照“人才新政12条”“人才新政3.0版”，对企业新培育、符合条件的专业技术人才发放职称提升奖励。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img src="../assets/imgs/craft/part-2-title.png" class="part-two-title-img" />
                <div class="part-title part-two-title" style="margin-top: 1.44rem">
                    需同时满足以下条件：
                </div>
                <div class="part-two-content">
                    <div v-for="item in part2" :key="item.id" style="margin-bottom: 0.22rem; position: relative">
                        <div class="part-two-dot">{{ item.id }}</div>
                        {{ item.text }}
                    </div>
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/craft/part-3-title.png" class="part-two-title-img" />
                <div class="part-three-items part-text" v-for="item in part3" :key="item.id" :style="item.boxHeight">
                    {{ item.text }}
                </div>
                <div class="part-text" style="color: #3d5aa3">
                    注：通过同级转评专业、先评高后评低等方式取得的职称，不享受职称提升奖励政策
                </div>
            </div>
            <div class="part-four">
                <img src="../assets/imgs/craft/part-4-title.png" class="part-two-title-img" />
                <div class="main-content">
                    <div class="part-four-items" v-for="item in part4" :key="item.id" :style="item.boxHeight">
                        <div :class="item.title">{{ item.label }}</div>
                        <div class="part-four-content1">
                            <span class="inside-title" v-if="item.content1.title">{{ item.content1.title }}</span>
                            {{ item.content1.text }}
                        </div>
                        <div class="part-four-content2" v-if="item.content2">
                            <div v-for="(item2, index2) in item.content2" :key="index2">
                                {{ item2 }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/16/label4.png" alt="" />
                <div class="content" style="font-weight: normal;">
                    按照每年度通知时间确定。
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/16/label5.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>

                        <div><a href="tel:028-61888121">028-61888121</a></div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市人力资源和社会保障局<br/>专业技术人员服务管理处
                    </div>
                </div>
            </div>
        </div>
        <call phone="028-61888121"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    name: "craft",
    data() {
        return {
            part2: [
                {
                    id: 1,
                    text:'在本市各级市场监督管理部门依法登记、具有独立法人资格，纳税关系在本市，属于我市重点产业链“链主企业”及上下游重点产业企业新培育的专业技术人才；'
                },
                {
                    id: 2,
                    text:'人才取得工程系列、自然科学系列副高级、正高级职称，并被所在企业聘任相应专业技术职务。'
                },
            ],
            part3: [
                {
                    id: 1,
                    boxHeight: "",
                    text: "（一）取得副高级职称，按3000元/人的标准给予一次性专业技术职称提升奖励。",
                },
                {
                    id: 2,
                    boxHeight: "",
                    text: "（二）取得正高级职称，按6000元/人的标准给予一次性专业技术职称提升奖励。",
                },
            ],
            part4: [
                {
                    id: 11,
                    title: "title-bg",
                    label: "集中申报",
                    content1: {
                        title: "",
                        text:"年度申报通知发放后，由企业通过“成都市急需紧缺人才服务管理系统”申报，并向单位注册地所在区（市）县人力资源和社会保障部门提供以下相关材料："
                    },
                    content2: [
                        "1．《成都市企业人才专业技术职称提升奖励申请表》;",
                        "2．企业营业执照原件及复印件，属于重点企业的证明材料原件及复印件;",
                        "3．专业技术人才的身份证（或护照）、职称证书、聘书、劳动合同的原件及复印件；社保缴纳证明；《专业技术职务任职资格评审表》和职称任职文件复印件，市级及以上人力资源和社会保障部门授权开展职称评审的文件等。",
                    ],
                    boxHeight: "",
                },
                {
                    id: 21,
                    label: "区（市）县初审推荐",
                    title: "title-bg title-bg2",
                    content1: {
                        title: "",
                        text: "区（市）县人力资源和社会保障部门网上初审和现场审核。",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 31,
                    label: "市级有关行业主管部门复核",
                    title: "title-bg title-bg3",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 41,
                    label: "公示确认",
                    title: "title-bg title-bg4",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "border:none;margin-bottom:0",
                },
            ],
        };
    },
    components: {
        // bottom,
        call,
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        // //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        // //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        height: 7.1rem;
        width: 7.5rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/16/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.35rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-text {
                    margin-top: 1.2rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        padding-left: 0.33rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-title {
            text-align: left;
            margin-left: 0.33rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.35rem;
            }
        }

        .part-two-content {
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
            width: 6.22rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 0.34rem 0.24rem 0.15rem 0.67rem;
            font-size: 0.26rem;
            // //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;

            .part-two-dot {
                position: absolute;
                top: 0;
                left: -0.46rem;
                width: 0.36rem;
                height: 0.36rem;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 0.26rem;
                background: #739bfe;
                border-radius: 50%;
            }
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.5rem 0.25rem 0.35rem 0.25rem;

        .part-three-items {
            width: 6.35rem;
            padding-bottom: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.22rem;
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.2rem 0.25rem 0.35rem 0.25rem;

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.9rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                // //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.35rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    // //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                }

                .title-bg3 {
                    width: 5rem;
                    height: 0.6rem;
                    background: url(../assets/imgs/Relocationallowance/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content2 {
                    font-weight: bolder;
                }
            }
        }
    }

    .part-five {
        width: 6.85rem;
        height: 1.17rem;
        background: #fff;
        margin-top: 0.32rem;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 0.25rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 0.34rem;
        // //font-family:: PingFang SC-Heavy, PingFang SC;
        font-weight: 800;
        color: #2350bf;
    }

    .bottom-info {
        margin-top: 0.22rem;
        font-size: 0.24rem;
        // //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;

        a {
            text-decoration: none;
            // color: #97a9d9;
        }
    }
}
</style>
